import { useMemo } from 'react';
import useHighlightTimelineItem from 'flow-doctor-lib/hooks/useHighlightTimelineItem';
import { getTimelineFilterStrategy } from 'flow-doctor-lib/utils/timelineItemStrategies';
import { getIsInternal } from 'flow-doctor-lib/constants/Env';
import EnrollmentTimeline from 'flow-doctor-lib/components/timeline/EnrollmentTimeline';
import { jsx as _jsx } from "react/jsx-runtime";
const RecordTimelineTabContent = ({
  diagnosisResult,
  selectedEnrollment
}) => {
  // Hide timeline items that shouldn't be shown for their respective environment
  const filteredTimelineItems = useMemo(() => {
    return diagnosisResult.timelineItems.filter(getTimelineFilterStrategy(getIsInternal() ? 'INTERNAL' : 'EXTERNAL'));
  }, [diagnosisResult.timelineItems]);

  // Modify the url hash to highlight the culprit event on the timeline
  useHighlightTimelineItem({
    timelineLogItems: filteredTimelineItems
  });
  return /*#__PURE__*/_jsx(EnrollmentTimeline, {
    flowId: selectedEnrollment.flowId,
    objectTypeId: selectedEnrollment.objectTypeId,
    timelineLogItems: filteredTimelineItems
  });
};
export default RecordTimelineTabContent;